import axios from 'axios';

export interface AnafDateGenerale {
    cui: number;
    data: string;
    denumire: string;
    adresa: string;
    telefon?: string;
    fax?: string;
    codPostal?: string;
    nrRegCom?: string;
    cod_CAEN?: string;
    iban?: string;
    statusRO_e_Factura?: boolean;
    stare_inregistrare?: string;
    organFiscalCompetent?: string;
    data_inregistrare?: string;
    forma_organizare?: string;
}

export interface AnafInregistrareScopTva {
    scpTVA: boolean;
    perioade_TVA?: Array<{
        data_inceput_ScpTVA?: string;
        data_sfarsit_ScpTVA?: string;
        data_anul_imp_ScpTVA?: string;
        mesaj_ScpTVA?: string;
    }>;
}

export interface AnafInregistrareRtvai {
    statusTvaIncasare: boolean;
    dataInceputTvaInc?: string;
    dataSfarsitTvaInc?: string;
    tipActTvaInc?: string;
    dataActualizareTvaInc?: string;
    dataPublicareTvaInc?: string;
}

export interface AnafStareInactiv {
    statusInactivi: boolean;
    dataInactivare?: string;
    dataReactivare?: string;
    dataPublicare?: string;
    dataRadiere?: string;
}

export interface AnafInregistrareSplitTva {
    statusSplitTVA: boolean;
    dataInceputSplitTVA?: string;
    dataAnulareSplitTVA?: string;
}

export interface AnafAdresaFiscal {
    ddenumire_Strada?: string;
    dnumar_Strada?: string;
    ddenumire_Localitate?: string;
    dcod_Localitate?: string;
    ddenumire_Judet?: string;
    dcod_Judet?: string;
    dcod_JudetAuto?: string;
    dtara?: string;
    ddetalii_Adresa?: string;
    dcod_Postal?: string;
}

export interface AnafAdresaSediuSocial {
    sdenumire_Strada?: string;
    snumar_Strada?: string;
    sdenumire_Localitate?: string;
    scod_Localitate?: string;
    sdenumire_Judet?: string;
    scod_Judet?: string;
    scod_JudetAuto?: string;
    stara?: string;
    sdetalii_Adresa?: string;
    scod_Postal?: string;
}

export interface AnafFoundItem {
    date_generale: AnafDateGenerale;
    inregistrare_scop_Tva?: AnafInregistrareScopTva;
    inregistrare_RTVAI?: AnafInregistrareRtvai;
    stare_inactiv?: AnafStareInactiv;
    inregistrare_SplitTVA?: AnafInregistrareSplitTva;
    adresa_domiciliu_fiscal?: AnafAdresaFiscal;
    adresa_sediu_social?: AnafAdresaSediuSocial;
}

export interface AnafTvaV9Response {
    found: AnafFoundItem[];
    notFound: number[];
}

export default class AnafTvaService {
    private static get API_URL() {
        return "/anaf-tva/api/PlatitorTvaRest/v9/tva";
    }

    public static async getCompanyDetails(cui: number): Promise<AnafFoundItem | null> {
        const date = new Date().toISOString().slice(0, 10);
        const payload = [{ cui, data: date }];

        const res = await axios.post<AnafTvaV9Response>(this.API_URL, payload, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            validateStatus: (s) => (s >= 200 && s < 300) || s === 404,
        });

        if (res.status === 404) return null;

        return res.data?.found?.[0] ?? null;
    }

    // În AnafService.ts (sau unde ai definit serviciul)
    static async getFinancialData(cui: number, an: number = 2023) {
        // Atenție: endpoint-ul este /bilant conform proxy-ului tău
        const response = await axios.get(`/anaf-tva/bilant?an=${an}&cui=${cui}`);
        return response.data;
    }
}

